import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-shop-cart-itens',
  templateUrl: './menu-shop-cart-itens.component.html',
  styleUrls: ['./menu-shop-cart-itens.component.css']
})
export class MenuShopCartItensComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
